// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".products{background-color:#fff}.paddingBottom{padding-bottom:30px}.marginBottom{margin-bottom:20px}", ""]);
// Exports
module.exports = exports;
